<template>
    <v-form ref="form">
        <v-row>
            <v-col cols="12" md="3">
                <v-text-field
                    label="Code"
                    :value="form.code"
                    outlined
                    dense
                    disabled
                    hide-details="auto"
                    background-color="disabled"
                >
                </v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3">
                <v-text-field 
                    label="PO Code"
                    :value="form.purchase_order_code"
                    outlined
                    dense
                    hide-details="auto"
                    disabled
                    background-color="disabled"
                >
                </v-text-field >
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <PDatePicker
                    label="Date"
                    v-model="form.date"
                    :rules="[isRequired]"
                    outlined
                    hide
                    dense
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <GeneralReceiptFormLine
                    v-for="(line, index) in form.lines"
                    :key="line.key"
                    v-model="form.lines[index]"
                    :dimensions="dimensions"
                    :dimensionsLoading="dimensionsLoading"
                    @deleteLine="handleDeleteLine(index)"
                    @update:dimension-search-input="searchDimensions"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-btn small depressed block @click="addLine">
                    <v-icon left>mdi-playlist-plus</v-icon>
                    add line
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { isRequired } from "./../../utils/validations"
import { randomSix } from '../../utils/toolkit';
import GeneralReceiptFormLine from './GeneralReceiptFormLine.vue'
import PDatePicker from './../common/PDatePicker.vue'
import dimensionAPI from './../../services/purchase/dimension'
export default {
    name: "GoodReceiptForm",
    components: {
        PDatePicker,
        GeneralReceiptFormLine,
    },
    props: {
        value: {
            type: Object,
        }
    },
    data() {
        return {
            form: {
                code: null,
                date: null,
                purchase_order_code: null,
                purchase_order_id: null,
                lines: [],
                notes: ''
            },
            line: {
                item_id: null,
                quantity: null,
                measure_unit_id: null
            },
            warehouseQuery: "",
            dimensions: [],
            dimensionsLoading: []
        }
    },
    watch: {
        form: {
            handler(form) {
                this.$emit("input", {...form, lines: [...form.lines]});
            },
            deep: true
        }
    },
    methods: {
        isRequired,
        addLine() {
            this.form.lines.push({...this.line, key: randomSix()})
        },
        handleDeleteLine(index){
            this.form.lines.splice(index, 1)
        },
        validate() {
            return this.$refs.form.validate();
        },
        searchDimensions(query) {
            this.dimensionsLoading = true;
            dimensionAPI.search(query).then(response => {
                this.dimensions = Array.from(new Set([...this.dimensions, ...response.data]))
            }).finally(() => {
                this.dimensionsLoading = false;
            })
        }
    },
    computed: {
    },
    mounted() {
        if(this.value) {
            this.form = {...this.value, lines: [...this.value.lines] };
            this.form.lines.forEach(line => {
                if(line.dimension) {
                    this.dimensions = Array.from(new Set([...this.dimensions, line.dimension]))
                }
            })
        }
    }
}
</script>

<style>

</style>